import { render, staticRenderFns } from "./subsomeone.vue?vue&type=template&id=5dfd98ae&scoped=true"
import script from "./subsomeone.vue?vue&type=script&lang=js"
export * from "./subsomeone.vue?vue&type=script&lang=js"
import style0 from "./subsomeone.vue?vue&type=style&index=0&id=5dfd98ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd98ae",
  null
  
)

export default component.exports